import { useCallback, useState } from 'react';

import useIdleTimer from 'hooks/useIdleTimer';

type WarningHook = (
  /**
   * Number of seconds before displaying the warning dialog
   */
  warnAfter: number,
  /**
   * Number of times the warning timer can be reset.
   */
  maxExtensions: number,
  enabled?: boolean,
) => [
  /**
   * Whether is warning should be shown
   */
  boolean,
  /**
   * Reset the warning timer (up to maxExtensions times)
   */
  () => void,
];

const useWarning: WarningHook = (warnAfter, maxExtensions, enabled = true) => {
  const [warned, setWarned] = useState<boolean>(false);
  const [extensions, setExtensions] = useState<number>(0);

  const onWarning = useCallback(() => {
    setWarned(true);
  }, [setWarned]);

  const [resetTimer] = useIdleTimer(onWarning, warnAfter * 1000, enabled);

  const extendSession = useCallback(() => {
    setWarned(false);
    setExtensions(extensions + 1);
    if (extensions + 1 < maxExtensions) {
      resetTimer();
    }
  }, [resetTimer, setWarned, extensions, setExtensions, maxExtensions]);

  return [warned, extendSession];
};

export default useWarning;
